export const PASSWORD_ALLOWED_CHARACTERS = '!@#$^&*_';
